import { api } from 'API';
import { APPLY_TYPES } from 'Enum/Applies';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/apply';

export interface IApplication {
  internetReqNum?: number;
  type: APPLY_TYPES;
  subject: string;
  subSubject: string;
  status: IStatus;
  reply: string;
  link: ILink;
  createDate: Date;
  shemeshCreateDate: Date;
  forwardedForProcessing: Date;
  replyDate: Date;
  closeDate: Date;
  statusDate: Date;
  shemeshApplyNumber: string;
  userNote: string;
  files: IFile[];
  adminIsrId?: string;
  benefits?: IBenefits[];
  medicalReferrals?: IMedicalReferrals[];
}

interface IStatus {
  status: number;
  statusDate: Date;
  description: string;
}

interface ILink {
  linkText: string;
  linkUrl: string;
  linkPrefixText: string;
  linkSuffixText: string;
}

interface IFile {
  id: number;
  userGivenName: string;
}

interface IBenefits {
  appMaanakSum: number;
  part: string;
  requestNumber: number;
  statusCode: number;
}

interface IMedicalReferrals {
  id: number;
  requestNumber: number;
  statusCode: number;
  catalogDesc?: string;
}

export interface IFileData {
  contentType: string;
  fileContentBase64: string;
}

export const getApplies = async (count?: number) => {
  const applicationsData = await api.get<IApplication[]>(
    addImposterToUrl(`${baseUrl}${count ? '?count=' + count : ''}`, !count)
  );
  if (applicationsData.data) {
    const sortedApplicationsData = applicationsData.data.sort(
      (a, b) =>
        new Date(b.createDate).getTime() - new Date(a.createDate).getTime()
    );

    return sortedApplicationsData;
  }
};

export const getUploadedFile = async (fileId: number) => {
  const fileData = await api.get<IFileData>(
    addImposterToUrl(`${baseUrl}/files/${fileId}`, true)
  );
  if (fileData.data) return fileData.data;
};
